
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aktuelt",
      function () {
        return require("private-next-pages/aktuelt/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/aktuelt"])
      });
    }
  